import { useInfiniteQuery } from '@tanstack/react-query'

import { chatKeys } from '../../keys'
import chatService from '../services'

import type { operations } from '@/schema'

type GetRoomsParams =
	operations['ChatController_getChatRooms']['parameters']['query']

export function useQueryChatRooms(params?: Omit<GetRoomsParams, 'start'>) {
	return useInfiniteQuery({
		queryKey: chatKeys.rooms(params),
		queryFn: ({ pageParam }) =>
			chatService.getRooms({
				...params,
				start: pageParam,
			}),
		initialPageParam: undefined as string | undefined,
		getNextPageParam: (lastPage) =>
			lastPage.pagination.hasMore ? lastPage.pagination.nextCursor : undefined,
	})
}
